import { Component, Input, Output, EventEmitter, ViewChild, OnDestroy, AfterViewInit, OnChanges, ElementRef, ViewEncapsulation } from '@angular/core';
import { WindowService } from 'shared/services/window/window.service';

const INNER_REFRESH_FRAME_EVENT_NAME = 'bold-refresh-integration';

@Component({
  selector: 'app-refreshable-frame',
  templateUrl: './refreshable-frame.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RefreshableFrameComponent implements OnDestroy, AfterViewInit, OnChanges {
  private _messageEventListener;

  constructor(private _window: WindowService) {
  }

  @ViewChild('iframeElement', { static: true })
  integrationIFrame: ElementRef;

  @Input()
  src: string;

  @Output()
  onSrcRefresh: EventEmitter<void> = new EventEmitter<void>();

  ngAfterViewInit(): void {
    this._messageEventListener = this._onRefreshEventFromIFrame.bind(this);
    this._window.addEventListener('message', this._messageEventListener, false);

    this._setIFrameSource(this.src);
  }

  ngOnChanges(): void {
    this._setIFrameSource(this.src);
  }

  ngOnDestroy(): void {
    if (this._messageEventListener) {
      this._window.removeEventListener('message', this._messageEventListener);
    }
  }

  refresh(): void {
    this._setIFrameSource(this.integrationIFrame.nativeElement.src);
  }

  private _onRefreshEventFromIFrame(eventData) {
    if (eventData.data === INNER_REFRESH_FRAME_EVENT_NAME && eventData.source === this.integrationIFrame.nativeElement.contentWindow) {
      this.onSrcRefresh.emit();
    }
  }

  private _setIFrameSource(source: string) {
    this.integrationIFrame.nativeElement.src = source;
  }
}
